<h1 mat-dialog-title>Manage scoped access</h1>
<div class="user-summary">
  <strong>{{user.firstName}} {{user.lastName}}</strong>
  <div>{{user.email}}</div>
  <div class="identifier">User ID: {{user.id}}</div>
</div>
<div class="dormant-notice" role="note">{{state.warning}}</div>
<div mat-dialog-content>
  @if (state.invalidated) {
    <p role="alert">Session, user, or API environment changed. Close and reopen this dialog.</p>
  }
  @if (state.catalogError) {
    <p role="alert">{{state.catalogError}}</p>
  }
  @if (state.companyError) {
    <p role="alert">{{state.companyError}}</p>
  }
  @if (state.mutationError) {
    <p role="alert">{{state.mutationError}}</p>
  }
  @if (state.success) {
    <p role="status">{{state.success}}</p>
  }
  @if (state.current) {
    <section aria-label="Record assignment" class="grant-form">
      <p><strong>{{state.bundle?.label || 'Payroll operations'}}</strong></p>
      @if (state.bundle) {
        <p>Catalog description: {{state.bundle?.description}}</p>
      }
      <p>Record at one company, immediately and without expiry. Lifecycle status does not indicate actual access.</p>
      <mat-form-field appearance="outline">
        <mat-label>Company</mat-label>
        <mat-select [(value)]="state.companyId" [disabled]="state.saving || state.pending || state.loading"
          panelClass="member-addedit-select-search-panel">
          <mat-option>
            <ngx-mat-select-search [formControl]="companySearch" placeholderLabel="Search companies or IDs..."
            noEntriesFoundLabel="No companies"></ngx-mat-select-search>
          </mat-option>
          @for (company of filteredCompanies; track company) {
            <mat-option [value]="company.id">{{company.name || 'Unnamed company'}} — {{company.id}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (state.companyId) {
        <div class="identifier">Selected company ID: {{state.companyId}}</div>
      }
      <button mat-raised-button color="primary" [disabled]="!state.canGrant" (click)="state.grant()">Record assignment</button>
    </section>
    <section aria-label="Assignment history">
      <h2>Recorded assignments</h2>
      <p>Assignment history; this is not a security audit log.</p>
      <mat-checkbox [checked]="state.includeHistory" [disabled]="state.saving || state.pending"
      (change)="state.history($event.checked)">Include revoked and expired history</mat-checkbox>
      <div class="toolbar">
        <button mat-button [disabled]="state.loading || state.saving" (click)="state.load()">Refresh / first page</button>
        <button mat-button [disabled]="state.loading || state.saving || state.pending || !!state.listError || !state.page?.nextCursor"
        (click)="state.load(state.page?.nextCursor || null)">Next page</button>
        <span>Up to 25 rows per page</span>
      </div>
      @if (state.loading) {
        <p role="status">Loading current assignments…</p>
      }
      @if (state.saving) {
        <p role="status">Recording operation…</p>
      }
      @if (state.listError) {
        <p role="alert">{{state.listError}} @if (state.success) {
          <span>The operation completed; the current list could not be reloaded.</span>
        }</p>
      }
      @if (state.page && (state.listError || state.needsReload)) {
        <p>Previously loaded rows below may be out of date.</p>
      }
      @if (state.page && !state.loading) {
        <p>Server enforcement status: {{state.page.enforcementStatus}} · Subject revision: {{state.page.revision}}</p>
        @if (!state.page.assignments.length && !state.listError && !state.needsReload) {
          <p>No recorded assignments in this view.</p>
        }
        @for (row of state.page.assignments; track row) {
          <article class="assignment">
            <strong>{{state.bundleLabel(row.bundleId)}}</strong>
            <div>{{state.companyLabel(row.scope.id)}}</div>
            <div class="identifier">{{row.scope.type}} ID: {{row.scope.id}}</div>
            <div>Recorded lifecycle: {{row.lifecycle}} (does not grant access)</div>
            <div>Created: {{row.createdAt | date:'medium'}} · Effective: {{row.effectiveAt | date:'medium'}}</div>
            <div>Expires: {{row.expiresAt ? (row.expiresAt | date:'medium') : 'No expiry'}}</div>
            @if (row.revokedAt) {
              <div>Revoked: {{row.revokedAt | date:'medium'}}</div>
            }
            <div class="identifier">Assignment ID: {{row.assignmentId}}</div>
            @if (row.bundleId !== 'payroll_operations') {
              <p>Historical bundle — display only.</p>
            }
            @if (row.bundleId === 'payroll_operations' && (row.lifecycle === 'effective' || row.lifecycle === 'scheduled')) {
              <button
              mat-button color="warn" [disabled]="!state.canRevoke(row)" (click)="state.revoke(row)">Revoke recorded assignment</button>
            }
          </article>
        }
      }
    </section>
    @if (state.uncertain) {
      <div class="pending-notice">
        <p>The same attempt is retained only while this dialog is open. Closing discards its retry key; it does not cancel or undo an operation. Reopen and inspect history before considering another operation.</p>
        <button mat-raised-button [disabled]="!state.canRetry" (click)="state.retry()">Retry same attempt</button>
      </div>
    }
  }
</div>
<div mat-dialog-actions align="end"><button mat-button (click)="close()">Close</button></div>
